import React, { useState } from "react";
import { Button } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import PaymentList from "../PaymentList/PaymentList.js";
import "./AddPayment.css";

const AddPayment = ({
  addPayment,
  tempPaymentList,
  setShowPopup,
  setPopupType,
  handleToggle,
  handleUpdatePayment,
  displayError,
  setCurrentPage,
}) => {
  const [userInput, setUserInput] = useState("");
  const tempPaymentListLength = tempPaymentList.length;
  const charLimit = 16;

  const handleChange = (e) => {
    const input = e.currentTarget.value;
    // Limit input to 16 characters
    const truncatedInput = input.slice(0, charLimit);
    setUserInput(truncatedInput);
  };

  const paymentInputCharLimits =
    userInput.trim().length > 0 && userInput.trim().length <= charLimit;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (paymentInputCharLimits) {
      addPayment(userInput);
      setUserInput("");
    }
  };

  return (
    <div className="add-payment">
      <h2 style={{ paddingLeft: "1rem" }}>{"HOW WILL YOU PAY THE DRAGON?"}</h2>
      <br />
      {/* input for payment */}
      <div
        style={{ minHeight: "3rem", paddingLeft: "1rem", paddingRight: "1rem" }}
      >
        <form onSubmit={handleSubmit}>
          {tempPaymentListLength < 3 && (
            <div className="paymentInputDiv">
              <input
                id="payment-input"
                style={{
                  fontSize: "16px",
                  width: "100%",
                  border: "none",
                  margin: "0",
                  boxSizing: "border-box",
                  padding: ".5px",
                  borderBottom: "1px solid grey",
                  textTransform: "lowercase",
                }}
                value={userInput}
                type="text"
                onChange={handleChange}
                placeholder="Enter Payment"
                disabled={tempPaymentListLength >= 3}
              />
              <button
                style={{
                  border: paymentInputCharLimits
                    ? "1px var(--text-color) solid"
                    : "1px grey solid",
                  marginBottom: "1px",
                  marginLeft: "1rem",
                  width: "4rem",
                  borderRadius: "10%",
                  color: paymentInputCharLimits ? "var(--text-color)" : "gray",
                }}
                type="button"
                onClick={handleSubmit}
                disabled={!paymentInputCharLimits}
                className="password-toggle"
              >
                ⏎
              </button>
            </div>
          )}
        </form>
      </div>

      {/* max char warning prompt for input */}
      <span
        style={{
          visibility: userInput.length === charLimit ? "visible" : "hidden",
          color: "rgb(154, 0, 0)",
          paddingLeft: "1rem",
        }}
      >
        ${charLimit} char max
      </span>

      {/* temp payment list counter */}
      <div className="addpaymentCounter">
        {tempPaymentListLength} of 3 payments
      </div>
      <br></br>
      {/* save payment button */}
      <div
        style={{
          paddingLeft: "1rem",
          paddingRight: "1rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {tempPaymentListLength >= 1 && (
          <>
            <Button
              className=""
              variant="contained"
              onClick={() => {
                setShowPopup(true);
                setPopupType("savePayments");
              }}
              sx={{
                backgroundColor: "rgb(118 47 51)",
                textTransform: "none",
                minHeight: "2.3rem",
                marginBottom: "0",
                "&:hover": {
                  backgroundColor: "rgb(94, 38, 41)", // Prevent color change on hover
                },
                "&:focus": {
                  backgroundColor: "rgb(94, 38, 41)", // Prevent color change on focus
                },
                "&:active": {
                  backgroundColor: "rgb(94, 38, 41)", // Prevent color change when active (clicked)
                  boxShadow: "none", // Disable any box shadow when active
                },
              }}
            >
              Save Payments
            </Button>
          </>
        )}
      </div>

      {/* Integrated Payment List */}
      <div>
        <PaymentList
          paymentList={tempPaymentList}
          handleToggle={(id) => handleToggle(id, "temp")}
          handleUpdatePayment={handleUpdatePayment}
          charLimit={charLimit}
        />
      </div>

      <div
        style={{
          position: "absolute",
          bottom: "2rem",
          right: "2rem",
        }}
        onClick={() => setCurrentPage("onboarding")}
      >
        what are payments?{" "}
        <InfoOutlinedIcon
          style={{ transform: "translateY(4px)", fontSize: "20px" }}
        />
      </div>

      <p
        style={{
          visibility: displayError === "" ? "hidden" : "visible",
          color: "rgb(154, 0, 0)",
        }}
      >
        {displayError}
      </p>
    </div>
  );
};

export default AddPayment;
